import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./navigation.scss";

const Navigation = () => {
  const location = useLocation();
  
  return (
    <nav className="main-navigation">
      <Link 
        to="/software" 
        className={`nav-link ${location.pathname === '/software' ? 'active' : ''}`}
      >
        software
      </Link>
      <span className="nav-separator">/</span>
      <Link 
        to="/music" 
        className={`nav-link ${location.pathname === '/music' ? 'active' : ''}`}
      >
        music
      </Link>
    </nav>
  );
};

export default Navigation;



